/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const termsEditorEndpointEditor = {
	commands: {
		toggleLeftPanel: "endpointEditor:commands.toggleLeftPanel#label",
		toggleRightPanel: "endpointEditor:commands.toggleRightPanel#label",
		hideAllPanels: "endpointEditor:commands.hideAllPanels#label",
		toggleConsole: "endpointEditor:commands.toggleConsole#label",
		saveResource: "endpointEditor:commands.saveResource#label",
		exportYaml: "endpointEditor:commands.exportYaml#label",
		undo: "endpointEditor:commands.undo#label",
		redo: "endpointEditor:commands.redo#label"
	},
	mainMenu: {
		sectionCreate: {
			action: {
				label: "endpointEditor:mainMenu.sectionCreate.action#label",
				tooltip: "endpointEditor:mainMenu.sectionCreate.action#tooltip"
			}
		}
	},
	inspector: {
		selectNodeToInspect: "endpointEditor:inspector.selectNodeToInspect",
		cannotEditMultipleNodes: "endpointEditor:inspector.cannotEditMultipleNodes"
	},
	endpointSettings: {
		label: "endpointEditor:endpointSettings#label",
		openDocumentation: "endpointEditor:endpointSettings.openDocumentation#label"
	},
	toasts: {
		savingAction: "endpointEditor:toasts.savingAction#message",
		actionHasBeenSaved: "endpointEditor:toasts.actionHasBeenSaved#message",
		failedToSaveAction: "endpointEditor:toasts.failedToSaveAction#message"
	},
	other: {
		historyNotAvailableYet: "endpointEditor:other.historyNotAvailableYet#tooltip"
	}
};
